import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lowerCase } from 'lodash-es';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { ServiceTemplateUsedIn } from '~/models/service-template/model';
import styles from './UpdateExistingServicesContent.module.scss';
const UpdateExistingServicesContent = (param)=>{
    let { serviceUsedIn } = param;
    const { control } = useFormContext();
    const { t: updateTexts } = useLocaleKeys('serviceBuilder.updateExisting');
    const usedInTypeToLabel = {
        [ServiceTemplateUsedIn.Draft]: updateTexts.applyToDrafts(),
        [ServiceTemplateUsedIn.ProposalTemplate]: updateTexts.applyToProposalTemplates()
    };
    const explanationText = (()=>{
        if (serviceUsedIn.length === Object.values(ServiceTemplateUsedIn).length) {
            return updateTexts.explanationBoth();
        }
        if (serviceUsedIn.length === 1) {
            return updateTexts.explanationSingle({
                usedInType: lowerCase(serviceUsedIn[0])
            });
        }
        return updateTexts.explanationBoth();
    })();
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                testId: "update-existing-services-explanation-text",
                children: [
                    explanationText,
                    /*#__PURE__*/ _jsx("br", {}),
                    updateTexts.chooseToUpdate()
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.checkboxes,
                children: [
                    ...serviceUsedIn
                ].sort().map((usedIn)=>/*#__PURE__*/ _jsx(Controller, {
                        control: control,
                        name: usedIn,
                        render: (param)=>{
                            let { field } = param;
                            return /*#__PURE__*/ _jsx(Checkbox, {
                                inline: true,
                                testId: "update-existing-services-".concat(usedIn, "-checkbox"),
                                checked: field.value,
                                onChange: (e)=>{
                                    field.onChange(e.target.checked);
                                },
                                bi: {
                                    name: 'update_existing_services_target',
                                    data: {
                                        used_in: usedIn
                                    }
                                },
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: usedInTypeToLabel[usedIn]
                                })
                            });
                        }
                    }, usedIn))
            })
        ]
    });
};
export default UpdateExistingServicesContent;
